export const ELayouts = {
	CATEGORIES: "withBubbles",
	SEARCHBAR: "withSearchBar",
};
